import moment from "moment";
import React, { useEffect, useState } from "react";
import "./monthView.scss";
import { cloneDeep, find, noop } from "lodash";
import { REMINDER_FUTURE_DATED_NO_ACTION, REMINDER_NO_ACTION, REMINDER_STATUS_COLOR_CODE, REMINDER_STATUS_COLOR_CODE_FOR_BACKGROUND } from "@utils/constants";
import { useRemindersContext } from "@components/drawerCalendar/useReminders";
import { ReminderTooltip } from "../reminderTooltip";
import { Badge, Tooltip } from "antd";
import Icon from "@assets/icon_config";
import { AllDayCadences, CalendarMonthViewWrapper } from "@components/drawerOutreaches/Cadence";
import { MONTH } from "@components/drawerCalendar/constant";

export const MonthView = ({ members, updateMembers, updateStatus }: any) => {
  const { monthReminders, setMonthReminders, editReminderHandler } = useRemindersContext();
  // const [reminders, setReminders] = useState<any>(monthReminders);
  // const [currentMonth, setCurrentMonth] = useState(moment(new Date()));
  // const [selectedDate, setSelectedDate] = useState(moment(new Date()));
  // const { selectDate, setSelectDate } = useRemindersContext();
  const { selectDate } = useRemindersContext();
  const [currentMonth, setCurrentMonth] = useState(moment(new Date()));
  const [selectedDate, setSelectedDate] = useState(moment(new Date()));

  useEffect(() => {
    setCurrentMonth(selectDate.clone().startOf("month"));
    setSelectedDate(selectDate);
  }, [selectDate]);

  const renderDays = () => {
    const dateFormat = "dddd";
    const days = [];

    let startDate = moment(currentMonth).startOf("week");

    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="ui-healthEm-month-view__header__day-date" key={i}>
          {moment(moment(startDate).add(i, "d")).format(dateFormat)}
        </div>
      );
    }

    return <div className="ui-healthEm-month-view__header">{days}</div>;
  };

  // Function to stop drop event propagation on reminder card
  const dragOver = (e: any) => {
    e.preventDefault();
  };

  // Function to handle when item is dropped
  const drop = (e: any) => {
    e.preventDefault();
    const draggedReminder = JSON.parse(e.dataTransfer.getData("reminder"));
    // const draggableElement = document.getElementById(id.id);
    // const targetDom = document.getElementById(`${cd[0]}--${cd[1]}`);
    const draggedReminderData = draggedReminder?.reminder;
    if (!draggedReminderData?.reminderStatus || draggedReminderData?.reminderStatus === REMINDER_NO_ACTION) {
      const targetDropContainer = e.target.id.split("--");
      let updatedReminderList: any = cloneDeep(monthReminders);
      const targetDate = targetDropContainer[1];

      const draggedReminderStartDate = moment.utc(draggedReminderData.reminderStartDate).local();
      const draggedReminderEndDate = moment.utc(draggedReminderData.reminderEndDate).local();

      if (draggedReminderStartDate.format("YYYY-MM-DD") !== targetDate) {
        const updatedReminderStartDateTime = moment(`${targetDate} ${draggedReminderStartDate.format("hh:mm:ss")}`);
        const updatedReminderEndDateTime = moment(`${targetDate} ${draggedReminderEndDate.format("hh:mm:ss")}`);
        const updatedReminder = { ...draggedReminderData, reminderStartDate: updatedReminderStartDateTime, reminderEndDate: updatedReminderEndDateTime };

        editReminderHandler(
          updatedReminder,
          () => {
            if (updatedReminderList[targetDate]) {
              if (!find(updatedReminderList[targetDate], { reminderId: draggedReminderData.reminderId })) {
                updatedReminderList[targetDate] = [
                  ...updatedReminderList[targetDate],
                  { ...draggedReminderData, reminderStartDate: updatedReminderStartDateTime, reminderEndDate: updatedReminderEndDateTime },
                ].sort((a, b) => {
                  const dateA = moment(a.reminderStartDate);
                  const dateB = moment(b.reminderEndDate);
                  return dateB.diff(dateA); // Compare in descending order
                });
              }
            } else {
              updatedReminderList[targetDate] = [{ ...draggedReminderData, reminderStartDate: updatedReminderStartDateTime, reminderEndDate: updatedReminderEndDateTime }];
            }
            if (!find(monthReminders[targetDate], { reminderId: draggedReminderData.reminderId })) {
              updatedReminderList[draggedReminder.day] = updatedReminderList[draggedReminder.day].filter((item: any) => item.reminderId !== draggedReminderData.reminderId);
              setMonthReminders(updatedReminderList);
            }
          },
          members,
          updateMembers,
          updateStatus
        );
      }
    }
  };

  // Function to handle when dragStarts
  const handleDragStart = (event: any, day: any, reminder: any, id: any) => {
    event.dataTransfer.setData("reminder", JSON.stringify({ day, reminder, id }));
  };

  const renderCells = () => {
    const monthStart = moment(currentMonth).startOf("month");
    const monthEnd = moment(currentMonth).endOf("month");
    const startDate = moment(monthStart).startOf("week");
    const endDate = moment(monthEnd).endOf("week");

    const rows = [];

    let days = [];
    let day = startDate;
    let formattedDate = "";

    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = moment(day).format("MMM DD"); //25
        const cloneDay = day; //25
        const formattedDateStamp = moment(day).format("YYYY-MM-DD");
        days.push(
          <Day
            day={day}
            cloneDay={cloneDay}
            formattedDate={formattedDate}
            formattedDateStamp={formattedDateStamp}
            monthStart={monthStart}
            selectedDate={selectedDate}
            onDateClick={onDateClick}
            reminders={monthReminders}
            handleDragStart={handleDragStart}
            drop={drop}
            dragOver={dragOver}
          />
        );
        day = moment(day).add(1, "d");
      }
      rows.push(
        <div className="ui-healthEm-month-view__content__row" key={day.toString()}>
          {days}
        </div>
      );
      days = [];
    }
    return <div className="ui-healthEm-month-view__content">{rows}</div>;
  };

  const onDateClick = (day: any) => {
    setSelectedDate(day);
  };

  return (
    <>
      {/* {renderHeader()} */}
      <div className="ui-healthEm-month-view">
        {renderDays()}
        {renderCells()}
      </div>
    </>
  );
};

const Day: any = ({ day, cloneDay, formattedDate, formattedDateStamp, monthStart, selectedDate, onDateClick, reminders, handleDragStart, drop, dragOver }: any) => {
  const [overFlowContainerVisibility, setOverFlowContainerVisibility] = useState(false);
  const { holidayList } = useRemindersContext();

  const onOverflowContainerVisibilityChange = (flag: any) => {
    setOverFlowContainerVisibility(flag);
  };

  return (
    <div
      className={`ui-healthEm-month-view__content__row__cell ${
        // !moment(day).isSame(moment(monthStart), "month") ||
        moment(day).day() === 0 || find(holidayList, { holiday_date: moment(day).format("YYYY-MM-DD") })
          ? "ui-healthEm-month-view__content__row__cell--disabled"
          : // : moment(day).isSame(moment(selectedDate), "day")
            // ? "ui-healthEm-month-view__content__row__cell--selected"
            ""
      }
      ${moment(day).isSame(moment(), "day") ? "ui-healthEm-month-view__content__row__cell--selected" : ""}`}
      id={`ui-healthEm-month-view--${formattedDateStamp}--cell-container`}
      key={day.toString()}
      // onClick={() => onDateClick(moment(cloneDay))}
      onDrop={drop}
      onDragOver={dragOver}
    >
      <div className="ui-healthEm-month-view-number" id={`ui-healthEm-month-view--${formattedDateStamp}--date-container`}>
        <span>
        {formattedDate}
        </span>
        <CalendarMonthViewWrapper
          cadenceComponent={
            <span >
              {
                reminders?.[formattedDateStamp]?.length > 0 &&
                <Badge count={reminders?.[formattedDateStamp]?.length}>
                    <Icon name={"reminderWithNoNotification"} height={22} width={22} /> 
                </Badge>
              }
            </span>
          }
        >
          <></>
        </CalendarMonthViewWrapper>
      </div>
      <CalendarMonthViewWrapper cadenceComponent={<AllDayCadences date={day} view={MONTH}  />} >
      <div id={`ui-healthEm-month-view--${formattedDateStamp}`} className="ui-healthEm-month-view__content__row__cell__reminders-container">
        {reminders?.[formattedDateStamp]?.length > 4 ? (
          <>
            {reminders?.[formattedDateStamp]?.slice(0, 3)?.map((reminderObj: any, index: any) => (
              <ReminderCard formattedDateStamp={formattedDateStamp} reminder={reminderObj} handleDragStart={handleDragStart} setOverFlowContainerVisibility={setOverFlowContainerVisibility} />
            ))}
            <Tooltip
              title={
                <OverflowRemindersTooltipContainer
                  formattedDateStamp={formattedDateStamp}
                  overflowItems={reminders?.[formattedDateStamp]?.slice(3)}
                  handleDragStart={handleDragStart}
                  setOverFlowContainerVisibility={setOverFlowContainerVisibility}
                />
              }
              open={overFlowContainerVisibility}
              onOpenChange={onOverflowContainerVisibilityChange}
              overlayClassName={"ui-healthEm-month-view__content__row__cell__reminders-container__reminder-card__overflow-items__tooltip"}
              trigger="click"
              placement="leftTop"
            >
              <div id={`ui-healthEm-month-view--${formattedDateStamp}--card-more-items`} className="ui-healthEm-month-view__content__row__cell__reminders-container__reminder-card__overflow-items">
                <span>{`+ ${reminders?.[formattedDateStamp]?.length - 3} more`}</span>
              </div>
            </Tooltip>
          </>
        ) : (
          reminders?.[formattedDateStamp]?.map((reminderObj: any, index: any) => <ReminderCard formattedDateStamp={formattedDateStamp} reminder={reminderObj} handleDragStart={handleDragStart} />)
        )}
      </div>
      </CalendarMonthViewWrapper>
    </div>
  );
};

const ReminderCard: any = ({ formattedDateStamp, reminder, handleDragStart, setOverFlowContainerVisibility = noop}: any) => {
  const [onDragStart, setOnDragStart] = useState(false);

  const {reminderId , patientName , reminderTitle , reminderStatus , recurrence} = reminder || {};

  return (
    <ReminderTooltip reminder={reminder} onDragStart={onDragStart} toggleCallback={() => {setOverFlowContainerVisibility(false)}}>
      <div
        id={`ui-healthEm-month-view--${formattedDateStamp}--${reminderId}`}
        className={`ui-healthEm-month-view__content__row__cell__reminders-container__reminder-card ${
          reminderStatus || reminderStatus === REMINDER_NO_ACTION ? "ui-healthEm-month-view__content__row__cell__reminders-container__reminder-card__disable-drag" : ""
        }`}
        draggable={!reminderStatus || reminderStatus === REMINDER_NO_ACTION}
        style={{
          background: `${ REMINDER_STATUS_COLOR_CODE_FOR_BACKGROUND[
            reminderStatus ? reminderStatus : moment.utc(reminder.reminderEndDate).local() < moment() ? REMINDER_NO_ACTION : REMINDER_FUTURE_DATED_NO_ACTION
          ]}`,
          borderLeft: `4px solid ${REMINDER_STATUS_COLOR_CODE[
            reminderStatus ? reminderStatus : moment.utc(reminder.reminderEndDate).local() < moment() ? REMINDER_NO_ACTION : REMINDER_FUTURE_DATED_NO_ACTION
          ]}`,
        }}
        onDragStart={(event) => {
          setOnDragStart(true);
          setOverFlowContainerVisibility(false);
          handleDragStart(event, formattedDateStamp, reminder, `ui-healthEm-month-view--${formattedDateStamp}--${reminderId}`);
        }}
        onDragEnd={() => setOnDragStart(false)}
      >
        <span
          id={`ui-healthEm-month-view--${formattedDateStamp}--${reminderId}--card-title`}
          className={`ui-healthEm-month-view__content__row__cell__reminders-container__reminder-card__title ${!patientName ? "clr-black" : ""}`}
        >
          {patientName || reminderTitle}
          {recurrence && (
            <span className="ui-healthEm-day-view__content__reminders-container__reminder__recurring-reminder-icon">
              <Icon name="refreshFilled" />
            </span>
          )}
        </span>
      </div>
    </ReminderTooltip>
  );
};

const OverflowRemindersTooltipContainer = ({ overflowItems, formattedDateStamp, handleDragStart, setOverFlowContainerVisibility }: any) => {
  return (
    <div className="ui-healthEm-month-view__content__row__cell__reminders-container__reminder-card__overflow-items__tooltip__container">
      {overflowItems?.map((reminder: any) => {
        return <ReminderCard formattedDateStamp={formattedDateStamp} reminder={reminder} handleDragStart={handleDragStart} setOverFlowContainerVisibility={setOverFlowContainerVisibility} />;
      })}
    </div>
  );
};
